import "core-js/stable";

// because IE11 sucks
window.bindEvent = (el, eventName, eventHandler) => {
    if (!el) { return; }

    try {
        if (document.addEventListener) {
            el.addEventListener(eventName, eventHandler, false);
        }
        else if (document.attachEvent) {
            el.attachEvent('on' + eventName, eventHandler);
        }
    }
    catch (err) {
        console.info('Error', err);
    }
};

// Look for scrolling
const checkScroll = () => {
    const docHTML = document.querySelector('html');

    if (window.scrollY >=100) {
        docHTML.classList.add('has-scrolled');
    } else {
        docHTML.classList.remove('has-scrolled');
    }
};

// on document ready
const domReady = () => {
    const docHTML = document.querySelector('html');

    // menu Toggling
    const menuOn = document.querySelector('.menu-open');
    window.bindEvent(menuOn, 'click', () => {
        docHTML.classList.add('menu-on');
    });
    const menuOff = document.querySelector('.menu-close');
    window.bindEvent(menuOff, 'click', () => {
        docHTML.classList.remove('menu-on');
    });

    // watch scroll
    checkScroll();
    window.bindEvent(window, 'scroll', checkScroll);

    // external links
    const links = document.querySelectorAll('a');
    links.forEach(el => {
        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(el.href)) {
            el.setAttribute('target', '_blank');
        }
    });

    // html5 form validation
    var formInputs = document.querySelectorAll("input[required], textarea[required], select[required]");
    var invalidMsg = document.querySelector('.form-msg-invalid').textContent;
    for (var i = 0; i < formInputs.length; i++) {
        formInputs[i].oninvalid = function(e) {
            e.target.setCustomValidity("");
            if (!e.target.validity.valid) {
                e.target.setCustomValidity(invalidMsg);
            }
        };
        formInputs[i].oninput = function(e) {
            e.target.setCustomValidity("");
        };
    }
};

if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
    domReady();
} else {
    document.addEventListener("DOMContentLoaded", domReady);
}